import React from 'react';
import { injectIntl } from 'react-intl';
import { InfoBox, Box } from '@landtrustinc/design-system';
import usePropertyAccess from '../../hooks/usePropertyAccess';

const SectionPropertyAccess = ({ publicData, intl }) => {
  const { policies, arrivalInstructions } = publicData || {};
  const { features } = usePropertyAccess({ arrivalInstructions, policies, intl });

  if (!features || features.length === 0) {
    return null;
  }

  return (
    <Box mb="var(--spacing-5)">
      <InfoBox
        heading={intl.formatMessage({ id: 'ListingPage.propertyAccessTitle' })}
        features={features}
      />
    </Box>
  );
};

export default injectIntl(SectionPropertyAccess);
